import { useTranslations } from '@vocab/react';
import {
  Box,
  Checkbox,
  IconHelp,
  Inline,
  Text,
  TooltipRenderer,
} from 'braid-design-system';

import translations from './.vocab';

interface Props {
  isHideNamesChecked: boolean;
  onChange: (value: boolean) => void;
}

export const EthicalHiringToggle = ({
  isHideNamesChecked,
  onChange,
}: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Inline space="xxsmall" alignY="center">
      <Checkbox
        checked={isHideNamesChecked}
        onChange={(event) => onChange(event.currentTarget.checked)}
        label={t('HIDE_NAMES_LABEL')}
        size="small"
      />
      <TooltipRenderer tooltip={<Text>{t('HIDE_NAMES_TOOLTIP')}</Text>}>
        {({ triggerProps }) => (
          <Box aria-label="Help" {...triggerProps}>
            <IconHelp />
          </Box>
        )}
      </TooltipRenderer>
    </Inline>
  );
};
